<template>
	<div
		:aria-selected="selected"
		:class="[{selected: selected}]"
		role="menuitemradio"
		class="menu-filter-option-item"
		tabindex="0"
		@click="onSelect"
		@keydown.space.prevent="onSelect"
	>
		<div class="menu-filter-option-item-icon-wrapper">
			<t-dot :hideDot="!value.isNew" color="yellow" style="margin-left: 16px;">
				<t-timpex-icon
					v-if="iconType == 'timpex'"
					:icon="icon"
					:class="[{selected: selected}]"
					class="menu-filter-option-item-icon"
				/>
				<t-timpex-icon
					v-else
					:icon="icon"
					:class="[{selected: selected}]"
					type="bp"
					size="sm"
					class="menu-filter-option-item-icon"
				/>
			</t-dot>
		</div>
		<span :class="[{selected: selected, bold: (bold || value.bold)}]" class="menu-filter-option-item-inner">
			<slot>{{value.description}}</slot>
		</span>

		<div v-show="hasCount" class="menu-filter-option-item-count">
			<t-pill :color="pillColor">
				{{count}}
			</t-pill>
		</div>

	</div>
</template>

<script>
import menuItemMixin from './menuItemMixin';
import menuOptionItemMixin from './menuOptionItemMixin';
import TPill from '../badges/TPill';
import TDot from '../badges/TDot';
import TTimpexIcon from '../timpex/icons/TTimpexIcon';
export default {
	name: 'TMenuFilterOptionItem',
	components: { TDot, TPill, TTimpexIcon },
	mixins: [ menuItemMixin, menuOptionItemMixin ],
	props: {
		count: Number,
		icon: {
			type: String,
			default: 'filter'
		},
		iconType: String,
	},
	computed: {
		hasCount() {
			return this.count && this.count > 0;
		},
		pillColor() {
			return this.value.isNew ? 'yellow' : '';
		}
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';
	.menu-filter-option-item {
		@extend %font-families-ui;
		@extend %text-small;
		user-select: none;
		color: get-color($text, 'muted');
		margin-top: 0;
		cursor: pointer;
		outline: none;
		display: flex;
		box-sizing: border-box;
		align-items: center;
		&.selected {
			background-color: rgba(16, 112, 202, 0.06);
		}
		&:hover {
			background-color: rgba(67, 90, 111, 0.04);
		}
		&:active {
			background-color: rgba(16, 112, 202, 0.06);
		}
		&:focus {
			background-color: rgba(16, 112, 202, 0.04);
		}
	}

	.menu-filter-option-item-icon-wrapper {
		display: flex;
		width: 27px;
		justify-content: center;
	}

	.menu-filter-option-item-icon {
		color: get-color($icon, 'default');
		height: 16px;
		box-sizing: border-box;
		&.selected {
			color: get-color($blue, 'base') !important;
		}
	}

	.menu-filter-option-item-inner {
		height: 32px;
		line-height: 32px;
		flex:1;
		margin-left: 16px;
		margin-right: 16px;
		box-sizing: border-box;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		font-weight: 500;
		&.bold {
			color: get-color($neutral, 'dark');
			font-weight: 600;
		}
		&.selected {
			color: get-color($blue, 'base');
		}
	}

	.menu-filter-option-item-count {
		min-width: 20px;
		margin-right: 16px;
	}
</style>
